export default __webpack_public_path__ + "static/media/blue-darken-for-water-budget-historical.45b25a40.svg";